import { useState, useEffect } from "react";
import DataTable from '../DataTable/DataTable';
import * as XLSX from "xlsx";
import { NotificationManager } from "react-notifications";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { convertDate } from "../AcitivityModal/assistingFunctions";
import { DateTime } from "luxon";
import "./requisitionReports.css";
import config from "../../Config.json";
import testinvitationreportapi from "../../apis/testinvitationreport/testinvitationreportapi";

const stylesSX = {
    odd: {
        background: '#F6F6F6 !important',
    },
    even: {
        background: '#ffffff !important',
    },
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    waitingText: {
        marginLeft: '5px',
    },
};

const Testinvitatioreport = ({
    userRecruitmentpartnerId,
    startSelectedDate,
    endSelectedDate,
    userRecords,
    exports,
    setTriggerTestInvitationReport
}) => {
    const [prevDates, setPrevDates] = useState({ start: startSelectedDate, end: endSelectedDate });
    const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [dataResult, setDataResult] = useState([]);
    const [totalResult, setTotalResult] = useState(0);
    const [isSearching, setIsSearching] = useState(true);
    const [isExporting, setIsExporting] = useState(false);

    const columns = [
        {
            accessorKey: "recruiterName",
            header: "Recruiter Name",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
        },
        {
            header: "Date of Sharing",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
            cell: ({ row }) => {
                return DateTime.fromISO(row.original.invitedDate).toFormat("MM-dd-yyyy");
            },
        },
        {
            header: "Organization Name",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
            cell: () => {
                return userRecords?.recruitmentpartner.name
            },
        },
        {
            accessorKey: "recruiterEmail",
            header: "Recruiter Email",
            width: "350px",
            enableSorting: false,
            enableFiltering: false,
        },
        {
            header: "Team",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
            cell: ({ row }) => {
                return row.original.teamdetails?.teamName ? row.original.teamdetails.teamName : "N/A";
            }
        },
        {
            header: "Division",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
            cell: ({ row }) => {
                return row.original.teamdetails?.divisionName ? row.original.teamdetails.divisionName : "N/A";
            }
        },
        {
            accessorKey: "candidateName",
            header: "Candidate Name",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
        },
        {
            accessorKey: "email",
            header: "Candidate Email",
            width: "350px",
            enableSorting: false,
            enableFiltering: false,
        },
        {
            accessorKey: "skillName",
            header: "Assessment Skillset",
            width: "250px",
            enableSorting: false,
            enableFiltering: false,
        },
        {
            header: "Test Invitation Status",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
            cell: () => {
                return "Invited";
            }
        },
        {
            accessorKey: "testName",
            header: "Test Name",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
        },
        {
            header: "Test Attempted",
            width: "200px",
            enableSorting: false,
            enableFiltering: false,
            cell: ({ row }) => {
                return row.original.testTaken ? "Yes" : "No";
            }
        },
        {
            accessorKey: "testScore",
            header: "Scrore (%)",
            width: "150px",
            enableSorting: false,
            enableFiltering: false,
        }
    ]

    const handlePageChange = (newPage, newPageSize) => {
        setPageNumber(newPage);
        if (newPageSize && newPageSize !== takeNumberOfResult) {
            setTakeNumberOfResult(newPageSize);
        }
    };

    const handlePageSizeChange = (newPageSize) => {
        setTakeNumberOfResult(newPageSize);
        setPageNumber(1);
    }

    const performSearch = async (
        userRecruitmentpartnerId,
        pageNumber,
        takeNumberOfResult,
        startSelectedDate,
        endSelectedDate,
    ) => {
        let payload = {
            recruitmentpartnerid: userRecruitmentpartnerId,
            page: pageNumber,
            size: takeNumberOfResult,
            formattedDatestart: convertDate(startSelectedDate),
            formattedDateend: convertDate(endSelectedDate),
        }
        try {
            setIsSearching(true);

            const res = await testinvitationreportapi(payload);

            if (res?.totalCount > 0) {
                const data = res.data;
                setDataResult(data);
                setTotalResult(res.totalCount);
            } else {
                setDataResult([]);
                setTotalResult(0);
            }
            setIsSearching(false);
        }
        catch (err) {
            NotificationManager.error("Error while fetching test invitation report", "Error", 3000);
            console.log(err);
        }

    }

    const exportToExcel = async () => {
        setIsExporting(true);
        setTriggerTestInvitationReport(false);
        const maxSize = config.MAX_SIZE  // API pagination size
        const end = Math.ceil(totalResult / maxSize);
        let pageStart = 1;
        const exportArr = [];

        try {
            for (let start = 0; start < end; start++) {
                let payload = {
                    recruitmentpartnerid: userRecruitmentpartnerId,
                    page: pageStart,
                    size: maxSize,
                    formattedDatestart: convertDate(startSelectedDate),
                    formattedDateend: convertDate(endSelectedDate),
                    isExport: true,
                }

                const res = await testinvitationreportapi(payload);

                if (res?.totalCount > 0) {
                    res.data.forEach((element) => {
                        let dataObj = {
                            "Recruiter Name": element.recruiterName,
                            "Date of Sharing": DateTime.fromISO(element.invitedDate).toFormat("MM-dd-yyyy"),
                            "Organization Name": userRecords?.recruitmentpartner.name,
                            "Recruiter Email": element.recruiterEmail,
                            "Team": element.teamdetails?.teamName ? element.teamdetails.teamName : "N/A",
                            "Division": element.teamdetails?.divisionName ? element.teamdetails.divisionName : "N/A",
                            "Candidate Name": element.candidateName,
                            "Candidate Email": element.email,
                            "Assessment Skillset": element.skillName,
                            "Test Name": element.testName,
                            "Test Invitation Status": "Invited",
                            "Test Attempted": element.testTaken ? "Yes" : "No",
                            "Scrore (%)": element.testScore,
                        }

                        exportArr.push(dataObj);
                    })
                }

                pageStart = pageStart + maxSize;
            }

            if (exportArr.length === 0) {
                NotificationManager.error("No data present", "Error", 3000);
                setIsExporting(false);
            } else {
                // Lazy load XLSX only when needed for export
                const { utils, writeFile } = await import("xlsx");
                const wb = utils.book_new();
                const ws = utils.json_to_sheet(exportArr);
                utils.book_append_sheet(wb, ws, "TestInvitationReport");

                writeFile(wb, `TestInvitationReport.xlsx`, { bookType: "xlsx", type: "file" });
                setIsExporting(false);
            }
        }
        catch (err) {
            console.log(err);
            NotificationManager.error("Error while exporting excel", "Error", 3000);
        }
    }

    useEffect(() => {
        if (exports) {
            exportToExcel();
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exports]);

    useEffect(() => {
        const datesChanged =
            prevDates.start !== startSelectedDate ||
            prevDates.end !== endSelectedDate;

        if (datesChanged) {
            setPrevDates({ start: startSelectedDate, end: endSelectedDate });
            if (pageNumber !== 1) {
                setPageNumber(1);
                return;
            }
        }

        const timer = setTimeout(() => {
            performSearch(
                userRecruitmentpartnerId,
                pageNumber,
                takeNumberOfResult,
                startSelectedDate,
                endSelectedDate,
            );
        }, 0);

        return () => clearTimeout(timer);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, takeNumberOfResult, startSelectedDate, endSelectedDate])

    return (
        <>
            <Backdrop sx={stylesSX.backdrop} open={isExporting}>
                <CircularProgress color="inherit" />
                <Typography sx={stylesSX.waitingText}>Please wait...</Typography>
            </Backdrop>

            <DataTable
                data={dataResult}
                columns={columns}
                isLoading={isSearching}
                totalRecords={totalResult}
                currentPage={pageNumber}
                pageSize={takeNumberOfResult}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                enableFiltering={false}
                enablePagination={true}
                enableSorting={false}
                pageSizeOptions={[10, 20, 50, 100]}
                isServerSide={true}
                className="kendo_reports"
                noDataText="No results found !"
            />
        </>
    )
}

export default Testinvitatioreport
